import { Components, Theme } from '@mui/material';

const MuiAccordion: Components<Theme>['MuiAccordion'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      paddingBottom: theme.spacing(theme.spacingSizes.lg),
      '&.Mui-expanded': {
        margin: 0,
      },
      '&.Mui-expanded::before': {
        opacity: 1,
      },
      '&.Mui-expanded + &.Mui-expanded::before': {
        display: 'block',
      },
    }),
  },
};

export default MuiAccordion;
